import React from 'react';
import '../feedbacks/feedbacks.css'
import { useGetAllQuestionQuery } from '../../services/feedbackApi';
import afatar from "../../images/femaleAfatar.png";

function Question() {
  const { data, isLoading, isError, error } = useGetAllQuestionQuery();

  if (isLoading) return (
    <div className="loading-spinner">
      <div className="spinner"></div>
      <p>Loading questions...</p>
    </div>
  );
  
  if (isError) return (
    <div className="error-message">
      <h2>An error occurred</h2>
      <p>{error?.error || 'Failed to load questions'}</p>
    </div>
  );

  const questions = [...(data || [])].reverse();

  return (
    <section className="feedback-section">
      <h1 className="section-title">Customers Questions</h1>
      
      <div className="cards-grid">
        {questions.map((question) => (
          <div key={question.id} className="feedback-card question-card">
            <img 
              src={afatar} 
              alt={question.userName} 
              className="user-avatar"
            />
            
            <h3 className="user-name">{question.userName}</h3>
            
            <p className="user-email">{question.email}</p>
            
            <p className="review-date">
              {new Date(question.messageDate).toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric',
                hour: '2-digit',
                minute: '2-digit'
              })}
            </p>
            
            <div className="message-label">Message:</div>
            <div className="message-content">{question.message}</div>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Question;